export default __webpack_public_path__ + "static/media/loader.01dd235e.png";